import { render, staticRenderFns } from "./DataBuildUnmatchedContacts.vue?vue&type=template&id=85794820&scoped=true"
import script from "./DataBuildUnmatchedContacts.vue?vue&type=script&lang=js"
export * from "./DataBuildUnmatchedContacts.vue?vue&type=script&lang=js"
import style0 from "./DataBuildUnmatchedContacts.vue?vue&type=style&index=0&id=85794820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85794820",
  null
  
)

export default component.exports